import './PercentCurrencyInputStyle.less';

import { CurrencyInput, NumberInput } from '@opendoor/bricks';
import classNames from 'classnames';
import React, { Component } from 'react';

import getCurrencyString from '../../helpers/getCurrencyString';

export interface IPercentCurrencyInputValue {
  percent: number;
  value: number;
  checkboxChecked: boolean;
}

export interface IPercentCurrencyInputProps {
  className?: string;
  disabled?: boolean;
  onChange?: (name: string, value: IPercentCurrencyInputValue) => void;
  name: string;
  percent?: number;
  total: number;
  value?: number;
  credit?: boolean;
  checkboxExists?: boolean;
  checkboxChecked?: boolean;
}

class PercentCurrencyInput extends Component<IPercentCurrencyInputProps> {
  public static defaultProps: Partial<IPercentCurrencyInputProps> = {
    disabled: false,
    onChange: () => {
      return;
    },
  };

  public componentWillReceiveProps(nextProps) {
    const { percent, total, checkboxChecked, value } = this.props;

    // total, which percent and value are based off may change
    // but percent and value may be out of sync
    if (total === nextProps['total']) {
      return;
    }
    if (percent !== nextProps['percent'] || value !== nextProps['value']) {
      return;
    }
    if (percent) {
      this.props.onChange(this.props.name, {
        checkboxChecked,
        percent,
        // we divide + multiply by 100 to round to the nearest 100
        // in order to circumvent an issue with CurrencyInput decimals + isAllowed
        value: Math.floor((nextProps['total'] * (percent / 100)) / 100) * 100,
      });
    } else {
      this.props.onChange(this.props.name, {
        checkboxChecked,
        percent: parseFloat(((value / nextProps['total']) * 100).toFixed(2)),
        value,
      });
    }
  }

  public pctOnChange = (name, percent) => {
    this.props.onChange(this.props.name, {
      checkboxChecked: this.props.checkboxChecked,
      percent,
      value: Math.floor((this.props.total * (percent / 100)) / 100) * 100,
    });
  };

  public valueOnChange = (name, value) => {
    this.props.onChange(this.props.name, {
      checkboxChecked: this.props.checkboxChecked,
      percent: parseFloat(((value / this.props.total) * 100).toFixed(2)),
      value,
    });
  };

  public checkboxOnChange = e => {
    const checkboxChecked = e.target.checked;
    this.props.onChange(this.props.name, {
      checkboxChecked,
      percent: this.props.percent,
      value: this.props.value,
    });
  };

  public render() {
    const {
      className,
      disabled,
      name,
      percent,
      checkboxChecked,
      checkboxExists,
      credit,
      value,
    } = this.props;

    if (disabled || checkboxExists) {
      const positive = credit ? '+' : '';
      const uncheckedClass =
        checkboxExists && !checkboxChecked && 'od-pct-currency-input__pct--unchecked';
      const dollars = credit ? `(${getCurrencyString(value)})` : getCurrencyString(value);
      return (
        <div className="od-pct-currency-input od-pct-currency-input__disabled">
          <span>
            {checkboxExists && (
              <input type="checkbox" checked={checkboxChecked} onChange={this.checkboxOnChange} />
            )}
          </span>
          <span className={classNames(uncheckedClass, 'od-pct-currency-input__pct--disabled')}>
            <span className="od-pct-currency-input__pct">{`${positive}${percent}%`}</span>
            <span>{dollars}</span>
          </span>
        </div>
      );
    }

    return (
      <div className={`od-pct-currency-input ${className ? className : ''}`.trim()}>
        <NumberInput
          className={'od-pct-currency-input__child'}
          content={percent}
          decimalPlaces={3}
          onChange={this.pctOnChange}
          name={`${name}-pct`}
          placeholder="0%"
          suffix={'%'}
        />
        <div className="od-pct-currency-input__line" />
        <CurrencyInput
          className={'od-pct-currency-input__child'}
          content={value}
          name={`${name}-currency`}
          onChange={this.valueOnChange}
          placeholder="$0"
        />
      </div>
    );
  }
}

export default PercentCurrencyInput;
